<template lang="html">
    <div id='app'>
        Hello World!
    </div>
</template>

<script>
import routes from '../../routes';
    export default {
        name: 'pdf',
        components: 
        {
        },
        created () {
            if (this.$route.query.id) {
                this.authCheck(this.$route.query.id);
            } 
        },
        mounted(){
        },
        data () {
            return {
                cid: '0a794f7f-809b-4561-9923-a4ceb9f89f77'
            }
        },
        methods: {
            async authCheck(id) {
                try {
                    let params = [];
                    params = {
                        'id': id
                    }
                    let reqeust = {params: params};
                    let auth = await this.$axios.get(this.$apiHost +"/"+this.$route.name+"/mediCheck", reqeust);
                    if (auth.data.flag) {
                        let barcode = this.$route.query.barcode
                        let path = 'http://localhost:8081' + '/pdf/' + barcode + '.png' ;
                        window.location.href = path;
                    } else {

                    }
                    return false;
                } catch (error) {
                    console.log(error)
                }
              
            }
        },
    }
</script>
''


// WEBPACK FOOTER //
// src/views/ex-api/Pdfauth.vue